import { Box, Paper, Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import AppTextInput from "../../app/components/AppTextInput";
import { MapTitlesToAutocompleteItems } from "../../app/utils/convertStaticDataToDropdownItems";
import DonationFormModel from "./common/donationFormModel";
import { useAppSelector } from "../../app/store/configureStore";
import AppAutocomplete from "../../app/components/AppAutocomplete";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

export default function PersonalDetails() {
    const appInsights = useAppInsightsContext();
    const methods = useFormContext();
    const { control, reset } = methods;

    const { titles } = useAppSelector(state => state.ReferenceData);
    const { personalDetails } = useAppSelector(state => state.personalDetail);

    const {
        formField: {
            Title,
            FirstName,
            Surname,
            PreferredPhoneNumber
        }
    } = DonationFormModel;

    useEffect(() => {
        if (personalDetails !== undefined && personalDetails !== null
            && titles && titles?.length > 0) {

            reset({
                [Title.name]: personalDetails.titleId === null
                    ? '' : personalDetails.titleId,
                [FirstName.name]: personalDetails.firstName,
                [Surname.name]: personalDetails.lastName,
                [PreferredPhoneNumber.name]: personalDetails.mobile
            });
        }
        appInsights.trackEvent({ name: "Donation - Personal details - on load" });
    }, [personalDetails, titles, reset]);

    return <>
        <Box sx={{ width: '100%' }} component={Paper}>

            <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

                <Grid size={{ xs: 12 }}></Grid>
                
                <Grid size={{ xs: 12 }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: "500" }}>Personal details</Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppAutocomplete control={control} name={Title.name} label={Title.label}
                        items={MapTitlesToAutocompleteItems(titles ?? [])} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppTextInput name={FirstName.name} label={FirstName.label} disabled={true}
                        maxStringCount={FirstName.maxStringCount} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppTextInput name={Surname.name} label={Surname.label} disabled={true}
                        maxStringCount={Surname.maxStringCount} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppTextInput name={PreferredPhoneNumber.name} label={PreferredPhoneNumber.label}
                        maxStringCount={PreferredPhoneNumber.maxStringCount} />
                </Grid>

                <Grid size={{ xs: 12 }}></Grid>

            </Grid>
        </Box>
    </>
}